import { render, staticRenderFns } from "./BookingPayment.vue?vue&type=template&id=4851d444&scoped=true&"
import script from "./BookingPayment.vue?vue&type=script&lang=js&"
export * from "./BookingPayment.vue?vue&type=script&lang=js&"
import style0 from "./BookingPayment.vue?vue&type=style&index=0&id=4851d444&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851d444",
  null
  
)

export default component.exports